import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const productsJsmIncidentCommandCenterRoute: InvariantJiraRoute = {
	name: 'products-jsm-incident-command-center',
	path: '/jira/settings/products/ops/incident-command-center',
	exact: true,
};
